// extracted by mini-css-extract-plugin
module.exports = {"Header":"ExistingUserLayout_Header__J0sZe","headContainer":"ExistingUserLayout_headContainer__8KRHZ","userName":"ExistingUserLayout_userName__R0VVp"};